import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {
  @Input() modalTitle: string
  @Input() dismissButtonLabel: string
  @Input() closeButtonLabel: string

  @ViewChild('modal', { static: false }) private modalContent: TemplateRef<ConfirmationModalComponent>
  private modalRef: NgbModalRef

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit() {
  }

  open(): Promise<any> {
    this.modalRef = this.modalService.open(this.modalContent);
    return this.modalRef.result;
  }

  async close() {
    console.log(`ConfirmationModalComponent closed`);
    this.modalRef.close(true);
  }

  async dismiss() {
    console.log(`ConfirmationModalComponent dismissed`);
    this.modalRef.dismiss('X');
  }

}
